import { createSlice } from "@reduxjs/toolkit";
import { IBookDemoData } from "../../../shared/utils/interfaces/bookDemoInterface";

const contactUsSlice = createSlice({
  name: "contactUs",
  initialState: {
    BookADemoModalOpen: false,
    iseBook: false,
    fromPage: localStorage.getItem('fromPage') || '',
    currentStepperStep: 0,
    bookDemoData: {},
    isThanksModalOpen: false,   // for demo only 
  },
  reducers: {
    setBookADemoOpen: (state, action) => {
      state.BookADemoModalOpen = action.payload;
    },
    setIseBook: (state, action) => {
      state.iseBook = action.payload;
    },
    setFromPage: (state, action) => {
      state.fromPage = action.payload;
    },
    setCurrentStepperStep: (state, action) => {
      state.currentStepperStep = action.payload;
    },
    setBookDemoData: (state, action) => {
      state.bookDemoData = action.payload;
    },
    setIsThanksModalOpen: (state, action) => {
      state.isThanksModalOpen = action.payload;
    },   // for demo only 
  },
});

export const {
  setBookADemoOpen,
  setIseBook,
  setFromPage,
  setCurrentStepperStep,
  setBookDemoData,
  setIsThanksModalOpen,   // for demo only 
} = contactUsSlice.actions;

export default contactUsSlice.reducer;

export const selectBookADemoOpen = (state: {
    contactUs: { BookADemoModalOpen: boolean };
}) => state.contactUs.BookADemoModalOpen;
export const selectIseBook = (state: {
  contactUs: { iseBook: boolean };
}) => state.contactUs.iseBook;
export const selectFromPage = (state: {
  contactUs: { fromPage: string };
}) => state.contactUs.fromPage;
export const selectCurrentStepperStep = (state: {
  contactUs: { currentStepperStep: number };
}) => state.contactUs.currentStepperStep;
export const selectBookDemoData = (state:{
  contactUs : {bookDemoData: IBookDemoData};
}) => state.contactUs.bookDemoData
export const selectIsThanksModalOpen = (state: {
  contactUs: { isThanksModalOpen: boolean };
}) => state.contactUs.isThanksModalOpen   // for demo only 
